import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check } from 'lucide-react'
import * as React from 'react'

import { cn } from '../../lib/utils'

/* base-ui's `data-[checked]` is Radix's `data-[state=checked]`; everything else
 * is the same markup. */
interface CheckboxProps
  extends Omit<React.ComponentProps<typeof CheckboxPrimitive.Root>, 'onCheckedChange'> {
  onCheckedChange?: (checked: boolean) => void
}

function Checkbox({ className, onCheckedChange, ...props }: CheckboxProps) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      onCheckedChange={(next) => onCheckedChange?.(next === true)}
      className={cn(
        'border-border-strong bg-bg-elev flex size-4.5 shrink-0 items-center justify-center rounded-sm border p-0 transition-colors duration-100 ease-out outline-none',
        'focus-visible:outline-accent focus-visible:outline-2 focus-visible:outline-offset-1',
        'data-[state=checked]:border-fg data-[state=checked]:bg-fg data-[state=checked]:text-bg',
        'data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="flex">
        <Check className="size-3" strokeWidth={3} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox, type CheckboxProps }
